module.exports = __webpack_public_path__ + "img/zhang_1.2fad602c.png";